import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Link } from 'react-router-dom'
import {CopyToClipboard} from 'react-copy-to-clipboard'

import { getFirstAccount } from 'modules/accounts'
import { getSubscriptionPlan } from 'modules/subscriptions'
import { getCurrentSiteId, getApiKeys } from 'modules/sites/selectors'
import { generateKey, deleteKey } from 'modules/sites/actions'
import { ACCOUNT_BILLING_PATH } from 'config'


class ApiKeys extends PureComponent {
  static propTypes = {
    account: PropTypes.shape({
      key: PropTypes.string.isRequired,
    }).isRequired,
    apiKeys: PropTypes.object,
    deleteKey: PropTypes.func.isRequired,
    generateKey: PropTypes.func.isRequired,
    siteId: PropTypes.string.isRequired,
    subscriptionPlan: PropTypes.string,
  }

  deleteKeyHandler(key) {
    this.props.deleteKey(this.props.account, this.props.siteId, key)
  }

  generateKey = () => {
    const { account, siteId, generateKey } = this.props;
    generateKey(account, siteId);
  }

  render() {
    const { account, siteId, subscriptionPlan } = this.props;

    return (
      <div className="card card-block">
        <h4 className="text-center mb-4">API Keys</h4>
        <div>
          <p>
            We provide an API so that you can integrate <span className="text-highlight">CacheReady</span> into your deployment workflow. To use it you will need to generate a key using the button below. You can remove your keys when you no longer need them, or get a new one at any time.
          </p>
          <p>API call for the current site will look like this:</p>
          <div className="form-group">
            <div className="input-group">
              <input type="text" className="form-control" value={`https://api.cacheready.com/sitemap/start/${account.key}/${siteId}?key=:key`} readOnly />
              <div className="input-group-btn">
                <CopyToClipboard text={`https://api.cacheready.com/sitemap/start/${account.key}/${siteId}?key=:key`}>
                  <button className="btn btn-primary"><i className="zmdi zmdi-copy" title="Copy to clipboard"/></button>
                </CopyToClipboard>
              </div>
            </div>
            <div className="col-sm-11">
            </div>
          </div>
          <p>where <span className="text-highlight">:key</span> - is an API key generated below.</p>
          <hr />
          {
            subscriptionPlan && subscriptionPlan !== 'basic' ?
              this.renderApiKeys() : this.renderUpgradeMsg()
          }
        </div>
      </div>
    )
  }

  renderApiKeys() {
    const { apiKeys } = this.props;

    return (
      <div className="api-keys-container">
        <button className="btn btn-primary mb-3" onClick={ this.generateKey }>Generate New Key</button>
        {
          apiKeys && (
            <ul className="list-group mb-3">
              { apiKeys.keySeq().map(key => (
                <li key={ key } className="list-group-item justify-content-between">
                  { key }
                  <i
                    className="zmdi zmdi-delete text-muted cursor-pointer"
                    onClick={ this.deleteKeyHandler.bind(this, key) }
                  />
                </li>
              )).toArray() }
            </ul>
          )
        }
      </div>
    )
  }

  renderUpgradeMsg() {
    return (
      <div className="text-center">
        <h5>API calls are not available on a basic plan. Please upgrade to use them.</h5>
        <Link to={ACCOUNT_BILLING_PATH} className="btn btn-primary m-3">Upgrade</Link>
      </div>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  account: getFirstAccount,
  apiKeys: getApiKeys,
  siteId: getCurrentSiteId,
  subscriptionPlan: getSubscriptionPlan,
})
export default connect(mapStateToProps, { generateKey, deleteKey })(ApiKeys)



// WEBPACK FOOTER //
// ./src/components/sites/keys.js